import { EVENT_STREAM_TYPE } from '../types/EventStream';
export function isEventStream(data) {
    return typeof data === 'object' && data?.type === EVENT_STREAM_TYPE;
}
export function createEventStream(onSubscribed, onUnsubscribed) {
    let listener;
    return {
        type: EVENT_STREAM_TYPE,
        listen(onData) {
            listener = onData;
            onSubscribed(onData);
        },
        unsubscribe() {
            onUnsubscribed(listener);
        },
    };
}
export function stateStream(dataInitializer) {
    let initialized = false;
    let currentData;
    let listeners = [];
    return {
        async eventStream() {
            if (!initialized) {
                currentData = await dataInitializer();
                initialized = true;
            }
            return createEventStream((emit) => {
                emit(currentData);
                listeners.push(emit);
            }, (emit) => {
                listeners = listeners.filter((emitter) => emitter !== emit);
            });
        },
        update(data) {
            listeners.forEach((listener) => listener(data));
            currentData = data;
        },
    };
}
//# sourceMappingURL=eventStream.js.map